import { render, staticRenderFns } from "./user-products.vue?vue&type=template&id=c46f0fe0&lang=pug"
import script from "./user-products.vue?vue&type=script&lang=js"
export * from "./user-products.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports